import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { siteCopyGuard } from "../../lib/api";

// Public marketing/guide pages only: no text selection, right-click, copy or image drag. Inputs and editable fields stay normal.
// The owner can switch it off from Admin → "Copy protection" (settings id site_copy_guard).
const EXEMPT_PREFIXES = ["/welcome", "/r/", "/a/", "/e/", "/s/", "/share", "/emergency", "/review", "/witness", "/memorial", "/tribute", "/m/"];
const editable = (el) => !!el?.closest?.("input, textarea, select, [contenteditable='true'], [data-allow-copy]");

export const useCopyGuard = (vaultPaths) => {
  const { pathname } = useLocation();
  const { data } = useQuery({ queryKey: ["site-copy-guard"], queryFn: siteCopyGuard, staleTime: 5 * 60 * 1000, retry: false });
  const enabled = data?.enabled ?? true;
  const isVault = vaultPaths.some((p) => pathname === p || pathname.startsWith(p + "/"));
  const active = enabled && !isVault && !EXEMPT_PREFIXES.some((p) => pathname.startsWith(p));
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add("hv-nocopy");
    const block = (e) => { if (!editable(e.target)) e.preventDefault(); };
    const keys = (e) => {
      const k = e.key?.toLowerCase();
      if ((e.ctrlKey || e.metaKey) && (k === "c" || k === "x" || k === "s" || k === "u" || (e.shiftKey && k === "i")) && !editable(e.target)) e.preventDefault();
    };
    document.addEventListener("contextmenu", block);
    document.addEventListener("copy", block);
    document.addEventListener("cut", block);
    document.addEventListener("dragstart", block);
    document.addEventListener("keydown", keys);
    return () => {
      document.body.classList.remove("hv-nocopy");
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("copy", block);
      document.removeEventListener("cut", block);
      document.removeEventListener("dragstart", block);
      document.removeEventListener("keydown", keys);
    };
  }, [active]);
  return active;
};

export const CopyGuard = ({ vaultPaths }) => { useCopyGuard(vaultPaths); return null; };
